import { render } from "./BlockContact.vue?vue&type=template&id=704be492&scoped=true"
import script from "./BlockContact.vue?vue&type=script&lang=js"
export * from "./BlockContact.vue?vue&type=script&lang=js"

import "./BlockContact.vue?vue&type=style&index=0&id=704be492&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704be492"]])

export default __exports__